import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store.js'
import VueCookies from 'vue-cookies'
import VueConfirmDialog from 'vue-confirm-dialog'
const fb = require('./firebaseConfig.js')


Vue.config.productionTip = false
Vue.use(VueConfirmDialog)
Vue.use(VueCookies)

Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
let app = '';


fb.auth.onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            router,
            store,
            VueCookies,
            render: h => h(App)
        }).$mount('#app')
    }
});